import React from 'react';
import { Divider, Form, Grid } from 'semantic-ui-react';
import { Field } from 'formik';
import KeywordList from 'Modules/MedicalCertificate/MedicalCertForm/KeywordList';
import { DIAGNOSIS_KEYWORD_LIST } from 'Modules/MedicalCertificate/MedicalCertForm/constants';
import { arrayOf, func, shape, string } from 'prop-types';
import { ANCHOR_RIGHT } from 'react-dates/constants';

import InputField from '../../Formik/Input/Input';
import DropdownField from '../../Formik/Dropdown/Dropdown';
import { SingleDatePickerField, TextAreaField } from '../../Formik';

import styles from './MedicalCertForm.less';

const MedicalCertForm = props => {
  const { certTypes, onClickKeyword, clinicName } = props;

  const certTypesOptions = certTypes.map(certType => ({
    key: certType.id,
    value: certType.id,
    text: certType.name,
    content: (
      <>
        <p className={styles.certTypeTitle}>{certType.name}</p>
        <p className={styles.certTypeDescription}>{certType.content}</p>
      </>
    ),
  }));

  return (
    <Form>
      <Field label="Name" placeholder="Patient name" name="patientName" component={InputField} />

      <Field
        label="NRIC/Passport number"
        placeholder="NRIC/Passport number"
        name="nricPassportNumber"
        component={InputField}
        onlyTyNumberAndLetter
      />

      <Divider />

      <Field
        label="Type of Medical Certificate"
        placeholder="Select type"
        name="medicalLeaveGrantedType"
        options={certTypesOptions}
        component={DropdownField}
        className={styles.customDropdown}
      />

      <Grid className={styles.dateWrapper}>
        <Grid.Row columns={2}>
          <Grid.Column className={styles.numberOfDaysWrapper}>
            <Field
              label="Number of days"
              placeholder="Number of days"
              name="numberOfDays"
              component={InputField}
              type="number"
            />
          </Grid.Column>
          <Grid.Column className={styles.startDateWrapper}>
            <Field
              label="Start date"
              placeholder="Start date"
              name="startDate"
              component={SingleDatePickerField}
              isOutsideRange={() => false}
              anchorDirection={ANCHOR_RIGHT}
              // isOutsideRange={day => moment.duration(day.diff(moment())).asDays() + 2 < 0}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <div style={{ marginBottom: '14px' }}>Clinic: {clinicName}</div>

      <Field
        label="Diagnosis"
        placeholder="Enter diagnosis"
        name="diagnosis"
        component={TextAreaField}
        keywordList={DIAGNOSIS_KEYWORD_LIST}
      />

      <KeywordList onClick={onClickKeyword} list={DIAGNOSIS_KEYWORD_LIST} />
    </Form>
  );
};

MedicalCertForm.propTypes = {
  certTypes: arrayOf(shape({})).isRequired,
  onClickKeyword: func.isRequired,
  clinicName: string,
};

export default MedicalCertForm;
